<template>
  <div class="options-editor">
    <div class="options-editor__header" v-if="headerIsVisible">
      <div class="options-editor__column"></div>
      <div class="options-editor__column">選項文字</div>
      <div class="options-editor__column text-center">管理</div>
      <div class="options-editor__column text-center" v-if="defaultOptionIsVisible">預設值</div>
    </div>
    <VueDraggable
      handle=".option-drag-handler"
      :list="vModelForOptions"
      @end="handleDragEnded"
      class="options-editor__body"
    >
      <div v-for="(option, optionIndex) in vModelForOptions" class="options-editor__row" :key="`opt-${optionIndex}`">
        <div class="options-editor__column">
          <i class="fa fa-bars option-drag-handler"></i>
        </div>
        <div class="options-editor__column options-editor__column--inputs">
          <template v-if="type === 'date'">
            <AppDatePicker
              v-model="option.value"
              @input="handleDateValueChanged(optionIndex, $event)"
            />
            <b-form-input
              v-model="option.text"
              placeholder="請填入顯示文字"
              class="options-editor__alias-input"
              @input="emitOptions"
            />
          </template>
          <b-form-input
            v-else
            v-model="option.text"
            @input="handleOptionValueChanged(optionIndex, $event)"
          />
        </div>
        <div class="options-editor__column">
          <b-button
            class="p-1 d-inline-flex align-items-center"
            variant="inverse-success"
            @click="handleCreateOptionClicked(optionIndex)"
          >
            <span class="mdi mdi-18px mdi-playlist-plus"></span>
            增加
          </b-button>
          <b-button
            class="ml-2 p-1 d-inline-flex align-items-center"
            variant="inverse-danger"
            @click="handleRemoveOptionClicked(optionIndex)"
            :disabled="hasOnlyOneOption"
          >
            <span class="mdi mdi-18px mdi-playlist-remove"></span>
            移除
          </b-button>
        </div>
        <div class="options-editor__column text-center" v-if="defaultOptionIsVisible">
          <b-form-radio
            v-model="defaultValue"
            :value="option.value"
            :disabled="hasOnlyOneOption"
            @change="$emit('update:defaultValue', option.value)"
          ></b-form-radio>
        </div>
      </div>
    </VueDraggable>
  </div>
</template>

<script>
import AppDatePicker from "@/components/AppDatePicker"
import VueDraggable from "vuedraggable"

export default {
  name: "OptionsEditor",
  components: {
    VueDraggable,
    AppDatePicker,
  },
  props: {
    type: {
      type: String,
      default: 'text',
    },
    value: {
      type: Array,
      default: () => [],
    },
    defaultValue: {
      type: String,
      default: '',
    },
    headerIsVisible: {
      type: Boolean,
      default: false,
    },
    defaultOptionIsVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    vModelForOptions: [],
  }),
  computed: {
    hasOnlyOneOption() {
      return this.vModelForOptions.length === 1
    },
  },
  watch: {
    value(optionsThroughProps) {
      this.syncPropValue(optionsThroughProps)
    },
  },
  mounted() {
    this.syncPropValue(this.value)
  },
  methods: {
    syncPropValue(optionValue) {
      const normalized =
        this.type === 'date' && Array.isArray(optionValue)
          ? optionValue.map((o) => ({
              ...o,
              value: o.value != null && o.value !== '' ? o.value : o.text,
            }))
          : optionValue
      this.$set(this, 'vModelForOptions', normalized)
      if (this.vModelForOptions.length === 0) {
        this.vModelForOptions.push({
          text: '',
          value: '',
        })
      }
    },
    emitOptions() {
      this.$emit('input', this.vModelForOptions)
    },
    handleDateValueChanged(optionIndex, value) {
      this.vModelForOptions[optionIndex].value = value
      this.emitOptions()
    },
    handleOptionValueChanged(optionIndex, value) {
      this.vModelForOptions[optionIndex].text = value
      this.vModelForOptions[optionIndex].value = value
      this.emitOptions()
    },
    handleCreateOptionClicked(optionIndex) {
      const clickedOptionValue = this.vModelForOptions[optionIndex].value
      const nextOptionIndex = optionIndex + 1

      this.vModelForOptions.splice(nextOptionIndex, 0, {
        text: this.type === 'date' ? '' : clickedOptionValue,
        value: clickedOptionValue,
      })

      this.emitOptions()
    },
    handleRemoveOptionClicked(optionIndex) {
      if (this.hasOnlyOneOption) return

      this.vModelForOptions.splice(optionIndex, 1)
      this.emitOptions()
    },
    handleDragEnded() {
      this.emitOptions()
    },
  }
};
</script>

<style lang="scss" scoped>
.options-editor {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 12px 16px;

  .options-editor__header {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: subgrid;
    align-items: center;
  }

  .options-editor__body {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: subgrid;
    gap: inherit;
  }

  .options-editor__row {
    display: grid;
    grid-column: 1 / -1;
    grid-template-columns: subgrid;
    align-items: center;
  }

  .options-editor__column--inputs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
  }

  .options-editor__alias-input {
    width: 200px;
    flex-shrink: 0;
  }
}
</style>
